// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { convertDMStoDD } from 'helpers/coordsConversion'
import { castToFloat } from 'helpers/reduxFormFunctions'
import { valueAsMeters } from 'helpers/unitConversion'

const formatSite = s => {
  const companyId = castToFloat(s.companyId)
  const contactId = castToFloat(s.contactId)
  const elevation = valueAsMeters(s.elevation, s.elevationUnit)
  const latitude = convertDMStoDD(s.latitude)
  const longitude = convertDMStoDD(s.longitude)
  const passiveFlag = s.passiveFlag
  const segmentEndId = castToFloat(s.segmentEndId)
  const siteName = s.siteName.trim()
  const stateId = castToFloat(s.stateId)

  return {
    companyId,
    contactId,
    elevation,
    latitude,
    longitude,
    passiveFlag,
    segmentEndId,
    siteName,
    stateId,
  }
}

export default formatSite
